import { Button, Card, Divider, Heading, Text } from '@ui/themed';
import { t } from 'i18next';
import { useEnv } from '../../../context/env-context';
import { useHandlers } from '../../../context/page-context';

const SPARKLAYER_FRONTPAGE_LINK = 'https://www.sparklayer.io/';

function getSparkLayerDemoLink(storeDomain?: string) {
  return storeDomain
    ? `${SPARKLAYER_FRONTPAGE_LINK}?demo=${storeDomain}&source=app`
    : SPARKLAYER_FRONTPAGE_LINK;
}

export function WhatIsSparkLayerCard() {
  const { store_id } = useEnv();
  const { navigationHandler } = useHandlers();
  const shopifyDemoLink = getSparkLayerDemoLink(store_id);

  return (
    <Card>
      {/* TODO: switch to a walkthrough video */}
      <Card.Header icon="playCircle" headingLevel="h2">
        {t('features:home.components.what_is_card.title')}
      </Card.Header>
      <Card.Body>
        {t('features:home.components.what_is_card.description')}
        <div className="mb-1 aspect-video w-full overflow-hidden rounded-lg">
          <iframe
            className="size-full"
            src="https://www.youtube.com/embed/23uqVqW59d0"
            title={t('features:home.components.what_is_card.video_title')}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <Divider />
        <div className="flex flex-col items-start justify-between gap-2 md:flex-row md:items-center">
          <div className="flex flex-col gap-2">
            <Heading level="h3" style="sm">
              {t('features:home.components.what_is_card.demo.title')}
            </Heading>
            <Text>{t('features:home.components.what_is_card.demo.description')}</Text>
          </div>
          <Button
            icon="externalLink"
            variant="secondary"
            onClick={() =>
              navigationHandler.navigate(shopifyDemoLink, {
                newTab: true,
                absolute: true,
              })
            }
          >
            {t('features:home.components.what_is_card.demo.action')}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
